import {Component} from '@angular/core';
import {RoleTypes, Roles} from "../../../models/roles";
import {Http} from "@angular/http";
import {Router} from "@angular/router";
import {ToasterService} from "angular2-toaster";
import {NewClientsStatsService} from "../../../models/new-clients-stats/new-clients-stats.service";
import {ClientsService} from "../../../models/clients/clients.service";
import {ClientStatusType} from "../../../models/clients/clients.type";
import {NewClientsStatsModel} from "../../../models/new-clients-stats/new-clients-stats.model";
import * as moment  from "moment";
import  * as _ from "lodash";
import {LeadsService} from "../../../models/leads/leads.service";
import {LeadsStatusType} from "../../../models/leads/leads.type";
import {PermissionsService} from "../../../services/permissions/permissions.service";
import {ApplicationUser} from "../../../services/ApplicationUser";

@Component({
    selector: 'lead-statistics',
    templateUrl: 'lead-statistics.template.html',
    styleUrls: ['style.css']
})
export class LeadStatisticsComponent {

    protected newClientStatsService;
    protected rolesService;
    protected clientsService: ClientsService;

    public leadsThisWeekTotal = 0;
    public leadsThisMonthTotal = 0;
    public leadsTodayTotal = 0;

    public leadsTodayByRole = {};
    public leadsThisWeekByRole = {};
    public leadsThisMonthByRole = {};

    public leadsThisWeekOptions;
    public leadsThisMonthOptions;
    public leadsTodayOptions;
    public submittedForMonthOptions;
    public leadsStats: any = {today: {}, week: {}, month: {}, lastWeek: {}};

    public submittedForMonth = [];
    public submittedForMonthTotal = 0;

    public roleNames = {};

    public roleTypes = RoleTypes;

    allowedOpenersForLeadStats: any = null;
    openerIdForLeadFilter: any = 0;

    selectedWeekStat: any = 'current';

    // ===========================================================
    // Init
    // ===========================================================


    constructor(private http: Http,
                private router: Router,
                private leadsService: LeadsService,
                public permission: PermissionsService,
                public appUser: ApplicationUser,
                private toasterService: ToasterService) {

        this.newClientStatsService = new NewClientsStatsService(this.http);
        this.rolesService = new Roles(this.http);
        this.clientsService = new ClientsService(this.http);
    }

    initLeadStats() {
        this.leadsStats.today = {
            chartType: 'PieChart',
            dataTable: [
                ['Task', 'Items'],
            ],
            options: {
                height: 400,
                is3D: true,
                bar: {groupWidth: "95%"}
            }
        };

        this.leadsStats.week = {
            chartType: 'Bar',

            dataTable: [
                this.getStatusesName(),
            ],
            options: {
                height: 500,
                bars: 'vertical',
                vAxis: {format: 'decimal'},
            }
        };

        this.leadsStats.lastWeek = {
            chartType: 'Bar',

            dataTable: [
                this.getStatusesName(),
            ],
            options: {
                height: 500,
                bars: 'vertical',
                vAxis: {format: 'decimal'},
            }
        };

        this.leadsStats.month = {
            chartType: 'ComboChart',
            dataTable: [
                ['Day','total', 'leads', 'amount']
            ],
            options: {
                height: 500,
                vAxis: {format: 'decimal'},
                seriesType: 'bars',
                series: {2: {type: 'line'}}
            }
        };
    }

    ngOnInit() {
        this.leadsThisWeekOptions = {
            chartType: 'PieChart',
            dataTable: [
                ['Task', 'Hours per Day'],
            ],
        };


        this.leadsThisMonthOptions = {
            chartType: 'PieChart',
            dataTable: [
                ['Task', 'Hours per Day'],
            ],
        };

        this.initLeadStats();

        this.leadsTodayOptions = {
            chartType: 'PieChart',
            dataTable: [
                ['Task', 'Hours per Day'],
            ],
        };

        this.submittedForMonthOptions = {
            chartType: 'PieChart',
            dataTable: [
                ['Task', 'Hours per Day'],
            ],
        };

        this.submittedForMonth = [
            {
                name: this.clientsService.statusNames[ClientStatusType.INCOMPLETE],
                amount: 25000,
            },
            {
                name: this.clientsService.statusNames[ClientStatusType.IN_DATA_ENTRY],
                amount: 25000,
            },
            {
                name: this.clientsService.statusNames[ClientStatusType.IN_UNDERWRITING],
                amount: 25000,
            },
            {
                name: this.clientsService.statusNames[ClientStatusType.APPROVED_NOT_FUNDED],
                amount: 25000,
            },
            {
                name: this.clientsService.statusNames[ClientStatusType.DECLINED],
                amount: 25000,
            },
            {
                name: this.clientsService.statusNames[ClientStatusType.FUNDED],
                amount: 25000,
            }

        ];


        this.submittedForMonthTotal = 0;
        this.submittedForMonth.forEach((item) => {
            this.submittedForMonthTotal += item.amount;

            this.submittedForMonthOptions.dataTable.push([item.name, item.amount]);
        });


        this.roleNames = {};
        this.roleNames[RoleTypes.LEAD_GENERATOR] = 'Web leads';
        this.roleNames[RoleTypes.REFERRAL_AGENT_OPENER] = 'Internal';
        this.roleNames[RoleTypes.REFERRAL_PARTNER_OPENER] = 'Referal partners';

        this.loadStatsNewClient();
        this.loadStatsLeads();

        this.leadsService.getAllowedOpenersForStats()
            .subscribe((res) => {
                this.allowedOpenersForLeadStats = res.data;
            });

    }


    // ===========================================================
    // Load Data
    // ===========================================================

    loadStatsNewClientOncer: any;
    public loadStatsNewClient() {

        this.loadStatsNewClientOncer = {};
        let _oncer = this.loadStatsNewClientOncer;

        let newClientsStats: NewClientsStatsModel[] = [];

        let leadsTodayByRole = {};
        let leadsThisWeekByRole = {};
        let leadsThisMonthByRole = {};

        this.newClientStatsService.getList()
            .subscribe((res) => {
                if (_oncer !== this.loadStatsNewClientOncer) return;

                newClientsStats = res.data;

                newClientsStats.forEach((newClientsStats) => {

                    // today
                    if (moment().format('YYYY-MM-DD') === newClientsStats.date.format('YYYY-MM-DD')) {
                        if (!leadsTodayByRole[newClientsStats.opener.role]) leadsTodayByRole[newClientsStats.opener.role] = 0;
                        leadsTodayByRole[newClientsStats.opener.role] += newClientsStats.count;
                    }

                    // this week
                    if (moment().format('w-YYYY') === newClientsStats.date.format('w-YYYY')) {
                        if (!leadsThisWeekByRole[newClientsStats.opener.role]) leadsThisWeekByRole[newClientsStats.opener.role] = 0;
                        leadsThisWeekByRole[newClientsStats.opener.role] += newClientsStats.count;
                    }

                    // this month
                    if (moment().format('YYYY-MM') === newClientsStats.date.format('YYYY-MM')) {
                        if (!leadsThisMonthByRole[newClientsStats.opener.role]) leadsThisMonthByRole[newClientsStats.opener.role] = 0;
                        leadsThisMonthByRole[newClientsStats.opener.role] += newClientsStats.count;
                    }
                });


                this.leadsTodayOptions = Object.create(this.leadsTodayOptions);
                for (var role in leadsTodayByRole) {
                    this.leadsTodayOptions.dataTable.push([this.rolesService.getNameByType(parseInt(role)), leadsTodayByRole[parseInt(role)]]);
                }

                this.leadsThisMonthOptions = Object.create(this.leadsThisMonthOptions);
                for (var role in leadsThisMonthByRole) {
                    this.leadsThisMonthOptions.dataTable.push([this.rolesService.getNameByType(parseInt(role)), leadsThisMonthByRole[parseInt(role)]]);
                }

                this.leadsThisWeekOptions = Object.create(this.leadsThisWeekOptions);
                for (var role in leadsThisWeekByRole) {
                    this.leadsThisWeekOptions.dataTable.push([this.rolesService.getNameByType(parseInt(role)), leadsThisWeekByRole[parseInt(role)]]);
                }


                this.leadsThisWeekTotal = _.sum(_.toArray(leadsThisWeekByRole));
                this.leadsTodayTotal = _.sum(_.toArray(leadsTodayByRole));
                this.leadsThisMonthTotal = _.sum(_.toArray(leadsThisMonthByRole));


                this.leadsTodayByRole = leadsTodayByRole;
                this.leadsThisWeekByRole = leadsThisWeekByRole;
                this.leadsThisMonthByRole = leadsThisMonthByRole;

            });
    }

    loadStatsLeadsOncer: any;
    isEmptyLeadStats: any = -1;
    public loadStatsLeads()
    {
        this.loadStatsLeadsOncer = {};
        let _oncer = this.loadStatsLeadsOncer;

        if (! this.isEmptyLeadStats) this.isEmptyLeadStats = true;

        this.leadsService.getStats(this.openerIdForLeadFilter)
            .subscribe((res) => {
                if (_oncer !== this.loadStatsLeadsOncer) return;

                this.isEmptyLeadStats = false;

                this.initLeadStats();

                this.leadsStats.today = Object.create(this.leadsStats.today);

                let weekData = this.getEmptyWeekStats();
                this.leadsStats.week = Object.create(this.leadsStats.week);

                let lastWeekData = this.getEmptyWeekStats(true);
                this.leadsStats.lastWeek = Object.create(this.leadsStats.lastWeek);

                let monthData = this.getEmptyMonthStats();
                this.leadsStats.month = Object.create(this.leadsStats.month);

                res.data.forEach((item: any) => {

                    // today
                    if (moment().format('YYYY-MM-DD') === moment(item.date).format('YYYY-MM-DD')) {
                        this.leadsStats.today.dataTable.push([this.leadsService.getStatusById(item.status), item.total]);
                    }

                    // this week
                    if (moment().format('w-YYYY') ===  moment(item.date).format('w-YYYY') ) {
                        if(weekData[item.date]){
                            weekData[item.date][item.status] = item.total;
                        }
                    }

                    if (moment().subtract(7, "days").format('w-YYYY') ===  moment(item.date).format('w-YYYY')) {
                        if (lastWeekData[item.date]) {
                            lastWeekData[item.date][item.status] = item.total;
                        }
                    }

                    // this month
                    if (moment().format('YYYY-MM') === moment(item.date).format('YYYY-MM')) {
                        if(monthData[item.date]){
                            if(item.status === LeadsStatusType.GENERATE_LEAD){
                                monthData[item.date].leads += item.total;
                            }
                            monthData[item.date].total += item.total;
                        }
                    }

                });

                for (let i in weekData) {
                    let row = [];
                    row.push(moment(i).format('dddd'));

                    for (let j in weekData[i]) {
                        row.push(weekData[i][j]);
                    }
                    this.leadsStats.week.dataTable.push(row);
                }

                for (let i in lastWeekData) {
                    let row = [];
                    row.push(moment(i).format('dddd'));

                    for (let j in lastWeekData[i]) {
                        row.push(lastWeekData[i][j]);
                    }
                    this.leadsStats.lastWeek.dataTable.push(row);
                }


                let amount = 0;
                for (let date in monthData) {
                    let row = [];

                    row.push(moment(date).format('DD'));

                    for (let j in monthData[date]) {

                        if(j === 'leads'){
                            amount += monthData[date][j];
                        }
                        monthData[date]['amount'] = amount;
                        row.push(monthData[date][j]);
                    }
                    this.leadsStats.month.dataTable.push(row);
                }

            });
    }

    setOpenerIdForLeadFilter() {
        this.loadStatsLeads();
    }


    // ===========================================================
    // Actions
    // ===========================================================


    // ===========================================================
    // Functions
    // ===========================================================
    
    private getEmptyWeekStats(lastWeek: any = false)
    {

        let allStatuses = this.leadsService.getAllStatuses();
        let defaultStatuses = {};
        for(let index in allStatuses){
            defaultStatuses[allStatuses[index].id] = 0;
        }

        let result = {};

        let firstWeekDay = moment().subtract(moment().weekday() + (lastWeek ? 7 : 0), "days");

        for (var i = 0; i < 7; i++) {
            let weekDate = firstWeekDay.subtract(-1, "days").format("YYYY-MM-DD");
            result[weekDate] = Object.assign({}, defaultStatuses);
        }

        return result;

    }

    private getEmptyMonthStats(){

        let endMonthDay = moment().endOf('month').format('DD');

        let result = {};

        let firstMonthDay = moment().startOf('month').subtract(1, "days");

        for (var i = 1; i <= +endMonthDay; i++) {
            let monthDate = firstMonthDay.subtract(-1, "days").format("YYYY-MM-DD");
            result[monthDate] = {total: 0 , leads: 0, amount: 0};
        }
        return result;

    }

    private getStatusesName() {

        let allStatuses = this.leadsService.getAllStatuses();
        let result = ['Day'];

        for(let index in allStatuses){
            result.push(allStatuses[index].name);
        }

        return result;
    }

    get canSeeFilter() {
        // not use on front - lock on back
        return true || this.permission.can('leads.all') || RoleTypes.OWNER === this.appUser.user.role;
    }
}


// WEBPACK FOOTER //
// ./src/app/views/leads/statistics/lead-statistics.component.ts